// Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
    return (
        <footer className=" tw-w-full tw-border-t tw-border-[#00c5fb7a] tw-text-sm tw-flex tw-flex-col md:tw-flex-row md:tw-items-center tw-justify-between tw-mx-auto tw-p-5 tw-gap-4">
            <div className="tw-flex tw-flex-col tw-gap-1">
                <div className="tw-flex tw-items-center tw-gap-2">
                    <span>powered by</span>
                    <img src="/logo.png" className="tw-h-3 tw-object-cover" alt="logo" />
                </div>
                <p className="tw-text-[10px] tw-text-gray-500">Protega is a product of Embedmike India Private Limited.</p>
            </div>
            <div className="tw-flex tw-flex-wrap tw-gap-4">
                <Link to={''} className="tw-mr-10 hover:tw-underline">Privacy Policy</Link>
                <Link to={''} className="hover:tw-underline">Terms and Conditions</Link>
            </div>
        </footer>
    );
};

export default Footer;
